<template>
  <div class="home">
    <div>
      <Jumbo
        :config="config"
        :title="title"
        :course="pastT"
        :season="seasonCode"
        :report="pastTournreport"
        :currentReport="currentReport"
        :tm="tm"
        :pastTourns="pastTourns"
        :futureTourns="futureTourns"
        :tournamentList="tournamentList"
        :pastT="pastT"
        :head="head"
        :tmparamsMini="tmparamsMini"
        :DEFIMAGESAMS3="DEFIMAGESAMS3"
        :apiClass="apiClass"
        :multiTourns="multi_tourns"
        :mutliData="mutliData"
      />
    </div>

    <div class="newsBackground">
      <b-container>
        <!-- <b-row>
          <b-col>
            <Ads
              class="mobHide"
              :page="'home'"
              :adNum="'top'"
              :mob="false"
              :side="false"
            />
          </b-col>
          <b-col>
            <Ads
              class="mobHide"
              :page="'home'"
              :adNum="'second'"
              :mob="false"
              :side="false"
            />
          </b-col>
        </b-row> -->
      </b-container>
      <b-container class="nocon" v-if="showbutton && tourSelect.LDS == 'Y'">
        <template>
          <div class="">
            <template v-if="pollsource == 'B' || pollsource == 'W' && pollgeneral == 'Y'">
              <template v-if="pollappImage != ''">
                <template v-if="pollType == 'E'">
                  <b-link @click="pollTypeEclick">
                    <img class="appImage pulse" :src="pollappImage">
                  </b-link>
                </template>
                <template v-else>
                    <img class="appImage pulse" v-b-modal.modal-xl :src="pollappImage">
                </template>
              </template>
              <template v-else>
                <template v-if="pollType == 'E'">
                  <b-link @click="pollTypeEclick">
                    <b-button variant="success" class="pulse"> Vote for Player of the Month</b-button>
                  </b-link>
                </template>
                <template v-else>
                    <b-button v-b-modal.modal-xl variant="success" class="pulse"> Vote for Player of the Month</b-button>
                </template>
              </template>
            </template>
          </div>
        </template>
      </b-container>

      <!-- Polls Section to test -->
        <b-modal id="modal-xl" size="xl">
          <b-container>
            <div v-for="(box, index) in Extradata" :key="index">
              <template v-if="thankyouMessage == 'N'">
                <div >
                  <b-row>
                    <b-col lg="6" sm="12">
                      <template v-if="box.website_video_url !== ''">
                        <template v-if="box.website_video_auto == 'Y'">
                          <iframe allowfullscreen aspect="16by9" muted playsinline allow='autoplay' :src="box.website_video_url + '&autoplay=1'" width="100%" height="300" style="border:none;"></iframe>
                        </template>
                        <template v-else>
                          <iframe allowfullscreen aspect="16by9" muted playsinline :src="box.website_video_url" width="100%" height="300" style="border:none;"></iframe>
                        </template>
                        <!-- <b-embed
                          type="iframe"
                          aspect="16by9"
                          :src="box.website_video_url"
                          allowfullscreen
                        ></b-embed> -->
                      </template>
                      <template v-else-if="box.website_image != ''">
                        <img v-if="box.website_image != ''" class="votePicture" :src="box.website_image">
                      </template>
                      <b-modal id="modal-1" title="Terms and Conditions" style="height: 600px; overflow: scroll;">
                        <h3 class="my-4 termsTitle" v-html="docTitle"></h3>
                        <p class="my-4 termsContent" v-html="docContent"></p>
                      </b-modal>
                    </b-col>
                    <b-col lg="6" sm="12">
                      <form class="formSection" ref="formdata">
                        <b-row>
                          <b-col lg="12" sm="12">
                            <p class="boxFull" v-if="box.full_desc != ''" v-html="box.full_desc"></p>
                          </b-col>
                          <!-- <b-col lg="6" sm="12">
                            <p class="boxexpiry" v-if="box.end_date != '' && box.end_time != ''" > Vote expiry date: {{box.end_date}} - {{box.end_time}} ({{timeZone}})</p>
                          </b-col> -->
                        </b-row>
                        <template v-if="box.anonymous == 'N'">
                          <b-row>
                            <b-col lg="5" sm="12">
                              <b-form-group
                                id="input-group-1"
                                label-for="input-1"
                              >
                                <b-form-input
                                  id="input-1"
                                  v-model="polfirstName"
                                  type="name"
                                  placeholder="Enter First Name"
                                  required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-group
                                id="input-group-1"
                                label-for="input-1"
                              >
                                <b-form-input
                                  id="input-1"
                                  v-model="polSurname"
                                  type="name"
                                  placeholder="Enter Surname"
                                  required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-group
                                id="input-group-1"
                                label-for="input-1"
                              >
                                <b-form-input
                                  id="input-1"
                                  v-model="polEmail"
                                  type="email"
                                  placeholder="Enter Email"
                                  required
                                ></b-form-input>
                              </b-form-group>
                              <div class="extraPadTop">
                                <b-form-checkbox
                                  id="checkbox-2"
                                  v-model="terms"
                                  name="checkbox-2"
                                  value="accepted"
                                  unchecked-value="not_accepted"
                                >
                                  I accept the <span class="termsandCon" @click="getTermsConditions" v-b-modal.modal-1>terms and conditions</span>
                                </b-form-checkbox>

                                <!-- <div>State: <strong>{{ terms }}</strong></div> -->
                              </div>
                              <!-- <div class="joinFanzon" v-if="box.askfanzone == 'Y'">
                                <b-form-checkbox
                                  id="checkbox-1"
                                  v-model="fanZonejoin"
                                  name="checkbox-1"
                                  value="Y"
                                  unchecked-value="N"
                                >
                                Join Fanzon
                                </b-form-checkbox>

                              </div> -->
                              <div class="deskHide">
                                <span style="font-weight:bold; padding-bottom: 10px; display:block">{{Extradata[0].question}}</span>
                                <b-row>
                                  <b-col cols="6" :class="{nameWidth : Extradata[0].showvotes == 'N' && Extradata[0].showpercent == 'N', nameWidth : Extradata[0].showvotes == 'N' || Extradata[0].showpercent == 'N'}">
                                    <lable v-if="box.multi_select == 'N'">
                                      <span class="titlesCol">
                                        Select one below
                                      </span>
                                    </lable>
                                    <lable v-else>
                                      <span class="titlesCol">
                                        Select one or more below
                                      </span>
                                    </lable>
                                  </b-col>
                                  <b-col v-if="Extradata[0].showvotes == 'Y'">
                                    <span class="titlesCol votes">
                                      Votes
                                    </span>
                                  </b-col>
                                  <b-col v-if="Extradata[0].showpercent == 'Y'">
                                    <span class="titlesCol perc">
                                      %
                                    </span>
                                  </b-col>
                                </b-row>
                                <b-form-group label="" v-slot="{ ariaDescribedby }">
                                  <b-row>
                                    <template v-if="box.multi_select == 'N'">
                                      <b-col lg="12" sm="12" v-for="(op, index) in box.opts.opts_entry" :key="index">
                                        <b-row>
                                          <b-col cols="6" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                            <b-form-radio v-model="Polselected" :aria-describedby="ariaDescribedby" name="some-radios" :value="index">
                                              {{op.desc}}
                                            </b-form-radio>
                                          </b-col>
                                          <b-col v-if="box.showvotes == 'Y'">
                                            <template v-if="box.showvotes == 'Y'">
                                              <span v-if="op.votes !== '0'">{{op.votes}}</span>
                                            </template>
                                          </b-col>
                                          <b-col v-if="box.showpercent == 'Y'">
                                            <template v-if="box.showpercent == 'Y'">
                                              <span>{{op.percent}}</span>
                                            </template>
                                          </b-col>
                                        </b-row>
                                      </b-col>
                                    </template>
                                    <template v-else>
                                      <b-col lg="12" sm="12">
                                        <div v-for="(op, index) in box.opts.opts_entry" :key="index">
                                        <b-row>
                                          <b-col :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                            <input type="checkbox" :value="index + 1" v-model="MultiPolselected">
                                            <label class="multiLable" :for="op.desc">{{op.desc}}</label>
                                          </b-col>
                                          <b-col v-if="box.showvotes == 'Y'">
                                            <template v-if="box.showvotes == 'Y'">
                                              <span v-if="op.votes !== '0'" class="opt">{{op.votes}}</span>
                                            </template>
                                          </b-col>
                                          <b-col v-if="box.showpercent == 'Y'">
                                            <template v-if="box.showpercent == 'Y'">
                                              <span class="percent">{{op.percent}}</span>
                                            </template>                                            
                                          </b-col>
                                        </b-row>
                                        </div>
                                      </b-col>
                                    </template>
                                  </b-row>
                                </b-form-group>
                              </div>
                              <!-- <div class="mt-3">Selected: <strong>{{ Polselected + 1 }}</strong></div> -->
                              <template v-if="polEmail !== '' && polEmail.includes('@') && polfirstName !== '' && polSurname !== '' && terms == 'accepted'">
                                <b-button type="button" class="buttonVote" variant="primary" @click="sendPollsData">Submit Vote</b-button>
                              </template>
                              <template v-else>
                                <b-button disabled class="buttonVote des">Submit Vote</b-button>
                              </template>
                            </b-col>
                            <b-col lg="7" sm="12" class="mobHide">
                              <span style="font-weight:bold; padding-bottom: 10px; display:block">{{Extradata[0].question}}</span>
                              <b-row>
                                <b-col lg="8" :class="{nameWidth : Extradata[0].showvotes == 'N' && Extradata[0].showpercent == 'N', nameWidth : Extradata[0].showvotes == 'N' || Extradata[0].showpercent == 'N'}">
                                  <lable v-if="box.multi_select == 'N'">
                                    <span class="titlesCol">
                                      Select one below
                                    </span>
                                  </lable>
                                  <lable v-else>
                                    <span class="titlesCol">
                                      Select one or more below
                                    </span>
                                  </lable>
                                </b-col>
                                <b-col lg="2" v-if="Extradata[0].showvotes == 'Y'">
                                  <span class="titlesCol votes">
                                    Votes
                                  </span>
                                </b-col>
                                <b-col lg="2" v-if="Extradata[0].showpercent == 'Y'">
                                  <span class="titlesCol perc">
                                    %
                                  </span>
                                </b-col>
                              </b-row>
                              <b-form-group label="" v-slot="{ ariaDescribedby }">
                                <b-row>
                                  <template v-if="box.multi_select == 'N'">
                                    <b-col lg="12" sm="12" v-for="(opts, index) in box.opts.opts_entry" :key="index">
                                      <b-row>
                                        <b-col lg="8" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                          <b-form-radio v-model="Polselected" :aria-describedby="ariaDescribedby" name="some-radios" :value="index">
                                            {{opts.desc}}
                                          </b-form-radio>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showvotes == 'Y'">
                                          <template v-if="box.showvotes == 'Y'">
                                            <span v-if="opts.votes !== '0'" class="">{{opts.votes}}</span>
                                          </template>
                                        </b-col>
                                        <b-col lg="2"  v-if="box.showpercent == 'Y'">
                                          <template v-if="box.showpercent == 'Y'">
                                            <span class="">{{opts.percent}}</span>
                                          </template>
                                        </b-col>
                                      </b-row>
                                    </b-col>
                                  </template>
                                  <template v-else>
                                    <b-col lg="12" sm="12">
                                      <b-row>
                                        <b-col lg="8" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                          <div v-for="(opts, index) in box.opts.opts_entry" :key="index">
                                            <input type="checkbox" :value="index + 1" v-model="MultiPolselected">
                                            <label class="multiLable" :for="opts.desc">{{opts.desc}}</label>
                                          </div>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showvotes == 'Y'">
                                          <template v-if="box.showvotes == 'Y'">
                                            <span v-if="opts.votes !== '0'" class="">{{opts.votes}}</span>
                                          </template>
                                        </b-col>
                                        <b-col lg="2"  v-if="box.showpercent == 'Y'">
                                          <template v-if="box.showpercent == 'Y'">
                                            <span class="">{{opts.percent}}</span>
                                          </template>
                                        </b-col>
                                      </b-row>
                                    </b-col>
                                  </template>
                                </b-row>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </template>
                        <template v-else>
                          <b-row>
                            <b-col lg="12" sm="12">
                              <b-form-group
                                id="input-group-1"
                                label-for="input-1"
                              >
                                <b-form-input
                                  id="input-1"
                                  v-model="polEmail"
                                  type="email"
                                  placeholder="Enter Email"
                                  required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-group label="Select one below" v-slot="{ ariaDescribedby }">
                                <b-row>
                                  <template v-if="box.multi_select == 'N'">
                                    <b-col lg="12" sm="12" v-for="(opts, index) in box.opts.opts_entry" :key="index">
                                      <b-row>
                                        <b-col lg="8" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                          <b-form-radio v-model="Polselected" :aria-describedby="ariaDescribedby" name="some-radios" :value="index">
                                            {{opts.desc}}
                                          </b-form-radio>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showvotes == 'Y'">
                                          <template v-if="box.showvotes == 'Y'">
                                            <span v-if="opts.votes !== '0'" class="">{{opts.votes}}</span>
                                          </template>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showpercent == 'Y'">
                                          <template v-if="box.showpercent == 'Y'">
                                            <span class="">{{opts.percent}}</span>
                                          </template>
                                        </b-col>
                                      </b-row>
                                    </b-col>
                                  </template>
                                  <template v-else>
                                    <b-col lg="12" sm="12">
                                      <b-row>
                                        <b-col lg="8" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N'}">
                                          <div v-for="(opts, index) in box.opts.opts_entry" :key="index">
                                            <input type="checkbox" :value="index + 1" v-model="MultiPolselected">
                                            <label class="multiLable" :for="opts.desc">{{opts.desc}}</label>
                                          </div>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showvotes == 'Y'">
                                          <template v-if="box.showvotes == 'Y'">
                                            <span v-if="opts.votes !== '0'" class="">{{opts.votes}}</span>
                                          </template>
                                        </b-col>
                                        <b-col lg="2"  v-if="box.showpercent == 'Y'">
                                          <template v-if="box.showpercent == 'Y'">
                                            <span class="">{{opts.percent}}</span>
                                          </template>
                                        </b-col>
                                      </b-row>
                                    </b-col>
                                  </template>
                                </b-row>
                              </b-form-group>
                              <template v-if="polEmail !== '' && polEmail.includes('@') && terms == 'accepted'">
                                <b-button type="button" class="buttonVote" variant="primary" @click="sendPollsData">Submit Vote</b-button>
                              </template>
                              <template v-else>
                                <b-button disabled class="buttonVote des">Submit Vote</b-button>
                              </template>
                            </b-col>
                          </b-row>
                        </template>
                      </form>
                    </b-col>
                  </b-row>
                </div>
              </template>
              <template v-else>
                <b-row>
                  <b-col lg="6" sm="12">
                    <img v-if="box.website_image != ''" class="votePicture" :src="box.website_image">
                  </b-col>
                  <b-col lg="6" sm="12">
                    <template v-if="voteData.status == 'FAIL'">
                      <h2 class="thankyou" v-html="voteData.message"></h2>
                    </template>
                    <template v-else>
                      <h2 class="thankyou">Thank you for your Vote</h2>
                    </template>
                  </b-col>
                </b-row>
              </template>
            </div>
          </b-container>
        </b-modal>

      <!-- End of Polls Section to test -->


      <b-container>
        <h1 class="NewsHomepage-Text">Top Stories</h1>
        <InterNews  :config="config" />
      </b-container>
      <b-container>
        <b-row>
          <b-col lg="4" md="12" sm="12"></b-col>
          <b-col lg="4" md="12" sm="12">
            <div class="whiteblock">
              <b-link :to="'/news'" class="newsAll">
                <span class="whitetext">See All News Stories </span>
              </b-link>
            </div>
          </b-col>
          <b-col lg="4" md="12" sm="12">
            <div class="logoBlock">
              <span class="newsLogos">
                <div class="logowidth">
                  <a
                    href="https://www.facebook.com/sunshineladiestour/"
                    target="_blank"
                  >
                    <img
                      class="socialLogosFooter"
                      src="https://live-sstlds.ocs-software.com/wp-content/uploads/2023/12/Group-333.png"
                    />
                  </a>
                </div>
                <div class="logowidth">
                  <a
                    href="https://www.instagram.com/sunshineladiestour"
                    target="_blank"
                  >
                    <img
                      class="socialLogosFooter"
                      src="https://live-sstlds.ocs-software.com/wp-content/uploads/2023/12/Group-332.png"
                    />
                  </a>
                </div>
                <!-- <div class="logowidth">
                  <a href="https://www.youtube.com/user/TheSunshineTour" target="_blank">
                    <img class="socialLogosFooter" src="https://updated.sunshinetour.com/wp-content/uploads/2022/07/YouTube_White.png">
                  </a>
                </div> -->
                <div>
                  <a href="https://twitter.com/i/flow/login?redirect_after_login=%2FSLadiesTour" target="_blank">
                    <img
                      class="socialLogosFooter"
                      src="https://live-sstlds.ocs-software.com/wp-content/uploads/2023/12/Group-329.png"
                    />
                  </a>
                </div>
              </span>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div>
      <UpComing
        :config="config"
        :tm="tm"
        :tournamentList="tournamentList"
        :fullList="fullList"
        :DEFIMAGESAMS3="DEFIMAGESAMS3"
        :season="seasonCode"
      />
    </div>

    <!-- <div class="middleAd-above-vid">
      <Ads
        class="mobHide"
        :page="'home'"
        :adNum="'third'"
        :mob="false"
        :side="false"
      />
    </div> -->

    <div class="oomSection">
      <b-container>
        <!-- <h1 class="orderOfMerit">Order Of Merit</h1> -->
        <RookieHome
          :Year="prevSeason"
          :config="config"
          :event_sponsor_logo="event_sponsor_logo"
          :DEFIMAGESAMS3="DEFIMAGESAMS3"
        />
      </b-container>
      <b-container>
        <!-- <h1 class="orderOfMerit">Order Of Merit</h1> -->
        <OOMHome
          :Year="prevSeason"
          :config="config"
          :event_sponsor_logo="event_sponsor_logo"
          :DEFIMAGESAMS3="DEFIMAGESAMS3"
        />
      </b-container>
    </div>
    <div class="oomSection statLeaderBlock">
      <b-container>
        <h1 class="orderOfMerit TitleStatLeader">Statistic Leaders</h1>
        <HomeStats
          :Year="seasonCode"
          :config="config"
          :currentOom="currentOom"
          :rookie="rookie"
          :stats="stats"
          :currentOomTitle="currentOomTitle"
          :rookieTitle="rookieTitle"
          :statsTitle="statsTitle"
          :DEFIMAGESAMS3="DEFIMAGESAMS3"
          :found="found"
        />
      </b-container>
    </div>
    <!-- <div class="theScoreBack">
      <b-container>
        <h1 class="orderOfMerit">The Score Featured Players Blog</h1>
        <ScoreNews
          :cat="'10'"
          :config="config"
          :DEFIMAGESAMS3="DEFIMAGESAMS3"
        />
      </b-container>
    </div> -->
    <div class="middleAd-above-vid">
      <!-- <span class="advertCen">ADVERT</span> -->
      <!-- <Ads class='mobHide' :page="'home'" :adNum="'third'" :mob='false' :side='false'/>   -->
    </div>
  </div>
</template>

<script>
// import Ads from "@/components/ads.vue";
import apiCall from "@/services/api.js";
// import MiniLeader from "@/components/miniLeader.vue";
// import Oom from "@/components/oom.vue";
import RookieHome from "@/components/rookieHomeSlider.vue";
import OOMHome from "@/components/oomHome.vue";
import HomeStats from "@/components/homeStats.vue";
import Jumbo from "@/components/jumbo.vue";
import InterNews from "@/components/interNews.vue";
import UpComing from "@/components/upComingTours.vue";
// import ScoreNews from "@/components/thescoreHome.vue";
import axios from "axios";
import * as CryptoJS from 'crypto-js';
export default {
  name: "home",
  props: ["season", "course", "currentReport", "title", "config", "apiClass"],
  components: {
    // MiniLeader,
    // Oom,
    Jumbo,
    InterNews,
    UpComing,
    OOMHome,
    // Ads,
    RookieHome,
    // ScoreNews,
    HomeStats
  },
  data: function() {
    const CryptoJSAesJson = {
      'stringify': (cipherParams) => {
        const j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};

        if (cipherParams.iv)
          j.iv = cipherParams.iv.toString();

        if (cipherParams.salt)
          j.s = cipherParams.salt.toString();

        return JSON.stringify(j);
      },
      'parse': (jsonStr) => {
        const j = JSON.parse(jsonStr);
        const cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});

        if (j.iv)
          cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);

        if (j.s)
          cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);

        return cipherParams;
      },
    };
    return {
      cryptoAES: CryptoJSAesJson,
      homepage: true,
      tm: [],
      featHome: "true",
      wpHome: [],
      pastT: [],
      head: [],
      tournamentList: [],
      tmparamsMini: [],
      currentOom: [],
      rookie: [],
      stats: [],
      pastTourns: [],
      futureTourns: [],
      fullList: [],
      pollData:[],
      polEmail: '',
      polfirstName: '',
      polSurname:'',
      Polselected: '',
      selectedPol:[],
      MultiPolselected: [],
      showbutton: '',
      timeZone: '',
      selectedItems: [],
      showbuttonExtra: [],
      appImage: '',
      // fanZonejoin: 'Y',
      thankyouMessage: 'N',
      voteData: {},
      terms: '',
      docTitle: '',
      docContent:'',
      pollsource: '',
      pollgeneral: '',
      pollMselect: '',
      pollappImage: '',
      pollType: '',
      pollTypeLink: '',
      Extradata: [],
      tourSelect: '',
      found: '',
      seasonCode: '',
      DEFIMAGESAMS3: '',
      multi_tourns: '',
      mutliData: '',
      event_sponsor_logo: '',
      currentOomTitle: '',
      rookieTitle: '',
      statsTitle: '',
      prevSeason: '226S'
    };
  },
  metaInfo() {
    return {
      title: "Ladies Sunshine Tour",
      meta: [
        { charset: "utf-8" },
        { name: "description", content: this.description }
      ]
    };
  },
  methods: {
    futureTours() {
      var data = this.tournamentList;
      return data
        .filter((tourn) => tourn.days_away.indexOf("-"))
        .slice(0, 3);
    },
    pastTours() {
      var data = this.tournamentList;
      return data
        .filter((tourn) => tourn.days_away < -1)
        .slice(-3);
    },
    getPolls() {
      axios
        .get(
          process.env.VUE_APP_APIFULL_URL +
            "tmticx?randomaddText=" +
            new Date().getTime()
        )
        .then(response => {
          this.Extradata = response.data;
          this.pollData = response.data.tm_params.polls;
          if (this.pollData != '') {
            this.showbutton = 'Y'
            if (Array.isArray(response.data.tm_params.polls.polls_entry)) {
              this.Extradata = response.data.tm_params.polls.polls_entry
            } else {
              console.log("is not Array");
              this.Extradata = [response.data.tm_params.polls.polls_entry];
            }
            // let arr = [];
            // console.log("this.arr")
            // console.log(arr)
            // this.Extradata.forEach((value, index) => {
            //     arr.push(value);
            //     console.log(value.source);
            //     console.log(index);
            // });
            this.pollsource = this.pollData.polls_entry.source;
            this.pollgeneral = this.pollData.polls_entry.general;
            this.pollMselect = this.pollData.polls_entry.multi_select;
            this.pollappImage = this.pollData.polls_entry.app_image;
            this.pollType = this.pollData.polls_entry.type;
            this.pollTypeLink = this.pollData.polls_entry.link_url;
            this.tourSelect = this.pollData.polls_entry.tours.tours_entry[1];
            console.log("this.tourSelect")
            console.log(this.tourSelect)
          } else {
            this.showbutton = 'N'
          }
        })
    },
    // Submiting Data for Polls when Anonymous is set to N
    sendPolls() {
      console.log('IN Send Polls')
      // MultiPolselected
      let voteCode = [];
      this.Extradata.forEach((value) => {
          voteCode.push(value.code);
      });
      this.voteCode = voteCode;
      this.selectedPol = this.Polselected + 1;
      let multiSeleted = []
      console.log("multiSeleted")
      console.log(multiSeleted)
      this.selectMulti = multiSeleted;

      this.MultiPolselected.forEach((value) => {
          multiSeleted.push(value);
      });

      if (this.pollMselect == 'Y') {
        console.log('MultiSelect')
				let sendpolls = '';

				sendpolls += 'sst' + ' ';
				sendpolls += this.polEmail  + ' ';
				sendpolls += '. W ';
        sendpolls += "'";
				sendpolls += 'fname|~' + this.polfirstName + "<!/D>" + "surname|~" + this.polSurname + "<!/D>" + "code|~" + this.voteCode + "<!/D>"
				for (const i of this.selectMulti) {
					sendpolls += 'option_' + (i) + '|~' + 'Y<!/D>';
        }
        // sendpolls += "fz|~" + this.fanZonejoin + "<!/D>";
        sendpolls += "'";
        // let sendpolls = "let " + this.polEmail + " . W 'fname|~" + this.polfirstName + "<!/D>" + "surname|~" + this.polSurname + "<!/D>" + "code|~" + this.voteCode + "<!/D>" + this.leg  + "|~Y<!/D>'"
        return sendpolls 
      } else if(this.pollType == 'E') {
        console.log('Poll Type == E')
        let sendpolls = '';
        sendpolls += 'sst' + ' ';
        sendpolls += '.'  + ' ';
        sendpolls += '. W ';
        sendpolls += "'";
        sendpolls += "code|~" + this.voteCode + "<!/D>";
        sendpolls += 'option_1' + '|~' + 'Y<!/D>';
        // sendpolls += "fz|~" + this.fanZonejoin + "<!/D>";
        sendpolls += "'";
        return sendpolls
      } else {
        console.log('NON MultiSelect')
        // let sendpolls = "let " + this.polEmail + '. W' + "'" + "fname|~" + this.polfirstName + "<!/D>" + "surname|~" + this.polSurname + "<!/D>" + "code|~" + this.voteCode + "<!/D>" + "option_" + this.selectedPol + "|~Y<!/D>" + "fz|~" + this.fanZonejoin + "<!/D>" + "'"
        let sendpolls = '';

				sendpolls += 'sst' + ' ';
				sendpolls += this.polEmail  + ' ';
				sendpolls += '. W ';
        sendpolls += "'";
				sendpolls += 'fname|~' + this.polfirstName + "<!/D>" + "surname|~" + this.polSurname + "<!/D>" + "code|~" + this.voteCode + "<!/D>"
				sendpolls += 'option_' + this.selectedPol + '|~' + 'Y<!/D>';
        // sendpolls += "fz|~" + this.fanZonejoin + "<!/D>";
        sendpolls += "'";
        return sendpolls
      }
		}, 
    pollTypeEclick() {
      let sktMsg = this.sendPolls()
      console.log("sktMsg")
      console.log(sktMsg)
      console.log('Send Poll Data -- E')
      this.$socket.emit('vote', sktMsg);
      window.open(this.pollTypeLink, '_blank');
    },
    sendPollsData() {
      let sktMsg = this.sendPolls()
      console.log("sktMsg")
      console.log(sktMsg)
      // this.$socket.emit('vote', sktMsg);
      this.$socket.emit('vote', sktMsg, (data) => {
        const jsonDoc = JSON.parse(data);
        this.voteData = jsonDoc;
        console.log("data")
        console.log(data)
      });
      this.thankyouMessage = 'Y' 
    },
    getTermsConditions: function() {
      axios
        .get(
          "https://ocs-africa.com/apps/marketing-terms.php?action=latest&tour=" + 'sst' + "&?randomadd=" +
            new Date().getTime()
        )
        .then((response) => {
          // this.showTerms = 'Y';
          // console.log("this.showTerms")
          // console.log(this.showTerms)
          this.docTitle = this.base64Decode(response.data.documents.document.title);
          console.log("this.docTitle")
          console.log(this.docTitle)
          this.docContent = this.base64Decode(response.data.documents.document.content);
          console.log("this.docContent")
          console.log(this.docContent)
        });
    },
    showStatus: function() {
      console.log('in Status')
      for (let i of this.tournamentList) {
        if(i.ts_final_result === 'Y'){
          console.log('found ' + 'Y');
          this.found = 'Y'
          return true;
        }
      }
      console.log('Y' + ' not there');
      this.found = 'N'
      return false;
    }
  },
  computed: {
    pastTournreport: function(r) {
      if (this.tm.past_tourns === "") {
        r = this.currentReport;
      } else {
        if (this.title.includes("Final")) {
          r = this.currentReport;
        } else {
          r =
            "https://sunshinetour.info/tic/tmlsmon.cgi?tourn=" +
            this.pastT +
            "~season=" +
            this.season +
            "~";
          // r = this.currentReport
        }
      }
      return r;
    }
  },
  async mounted() {
    var json = "wp/v2/pages/28418";
    try {
      this.getPolls();
      // First call, await for call to return
      let first_call = await apiCall.tmSeasonBase();
      this.seasonCode = first_call.data.tm_params.season_code;
      console.log("this.seasonCode--859")
      console.log(this.seasonCode)
      this.multi_tourns = first_call.data.multi_tourns;
      this.mutliData = first_call.data;
      this.loading = false;
      // Second call, await for call to return
      let second_call = await apiCall.wpInfo(json);
      this.wpHome = second_call.data;
      this.loading = false;
      // Second call, await for call to return
      let third_call = await apiCall.tmHomepage(this.seasonCode);

      console.log("third_call -- Homepage")
      console.log(third_call)
      this.tournamentList = third_call.data.tournaments.tournaments_entry;
      this.showStatus();
      this.fut = this.futureTours();
      this.past = this.pastTours();
      this.fullList = this.past.concat(this.fut);
      this.tmparamsMini = third_call.data;
      this.tm = third_call.data;
      if (
        this.tm.past_tourns != "" &&
        typeof this.tm.past_tourns.past_tourns_entry != "undefined"
      ) {
        if (!Array.isArray(this.tm.past_tourns.past_tourns_entry)) {
          this.tm.past_tourns.past_tourns_entry = [
            this.tm.past_tourns.past_tourns_entry
          ];
        }
        this.pastTourns = this.tm.past_tourns.past_tourns_entry;
      }
      if (
        this.tm.future_tourns != "" &&
        typeof this.tm.future_tourns.past_tourns_entry != "undefined"
      ) {
        if (!Array.isArray(this.tm.future_tourns.past_tourns_entry)) {
          this.tm.future_tourns.past_tourns_entry = [
            this.tm.future_tourns.past_tourns_entry
          ];
        }
        this.futureTourns = this.tm.future_tourns.past_tourns_entry;
      }
      this.pastT = third_call.data.code;
      this.head = third_call.data.full_name;
      this.DEFIMAGESAMS3 = third_call.data.tm_params.DEFIMAGESAMS3;
      console.log("this.DEFIMAGESAMS3");
      console.log(this.DEFIMAGESAMS3);
      // OOM Slider
      this.event_sponsor_logo = third_call.data.oom.event_sponsor_logo;
      // End OOM Slider
      // OOM
      this.currentOom = third_call.data.oom.oom.oom_entry;
      this.currentOomTitle = third_call.data.oom.full_name;
      // End OOM
      // RK
      this.rookie = third_call.data.rookie.oom.oom_entry;
      console.log("this.rookie");
      console.log(this.rookie);
      this.rookieTitle = third_call.data.rookie.full_name;
      // End RK
      // stats
      this.stats = third_call.data.stat.oom.oom_entry;
      this.statsTitle = third_call.data.stat.full_name;
      // End stats
      this.loading = false;
    } catch (error) {
      console.log("error in await calls");
      console.log(error);
      throw error;
    }
  }
};
</script>

<style scoped>
.pulse {
  animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  50% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }

  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
div#modal-1___BV_modal_content_ {
    height: 600px;
    overflow: scroll;
}
span.termsandCon {
  text-decoration: underline;
}
h2.thankyou {
  color: #00477c;
  text-align: center;
  margin-top: 120px;
}
.extraPadTop {
  padding-top: 30px;
}
.opt {
  position: absolute;
  right: 0;
  top: 0;
}
.multiLable {
  padding-left: 15px;
}
.appImage {
  width: 300px;
  position: absolute;
  right: 12em;
  margin-top: 18px;
}
.appImageLeft {
  width: 300px;
  position: absolute;
  left: 11em;
  margin-top: 18px;
}
::v-deep header#modal-xl___BV_modal_header_ {
  display: none!important;
}
.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
  display: none!important;
}
.pulse {
  animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(82, 255, 131, 0.7);
  }
  
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
  }
  
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
  }
}
button.btn.btn-success {
  /* position: absolute; */
  right: 14em;
  margin-top: -70px;
  width: 100%;
  height: 50px;
  margin-bottom: 90px;
  background-color: #93278f;
  border-color: #93278f;
}
button.btn.buttonVote.des.btn-secondary.disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  cursor: not-allowed;
}
p.boxFull {
  color: #01477b;
  font-size: 12pt;
  padding-bottom: 0px;
}
.boxexpiry {
  color: #01477b;
  font-size: 12pt;
  padding-bottom: 30px;
}
.formSection {
  padding-top: 30px;
  background: white;
  padding: 40px;
  font-size: 13pt;
  color: #00477c;
  padding-top: 0px;
}
.votePicture {
  width: 100%;
}
.buttonVote {
  background-color: #01477b;
  border-radius: 0;
  padding: 11px 30px;
  margin-bottom: 8px;
  border-color: #01477b;
  margin-top: 20px;
}
.playerofMonth {
  font-size: 2rem;
  color: #01477b;
  font-weight: 400;
  padding-bottom: 20px;
}
::v-deep .middleAd-above-vid {
  display: inline-block;
  width: 100%;
}
::v-deep button.btn.pastbtn.btn-secondary {
  /* background: #93278f; */
  background: #f8635f;
  border: none;
  border-radius: 10px 10px 0px 0px;
  font-size: 13px;
  text-align: center;
  color: #ffffff;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  box-shadow: 0 0 0 0rem rgb(130 138 145 / 50%);
}
::v-deep button.btn.pastbtn.btn-secondary.activeBtn {
  /* background: #f8635f; */
  background: #93278f;
  border: none;
  border-radius: 10px 10px 0px 0px;
  font-size: 13px;
  text-align: center;
  color: #ffffff;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  box-shadow: 0 0 0 0rem rgb(130 138 145 / 50%);
}
h1.orderOfMerit.TitleStatLeader {
  margin-bottom: 60px;
}
.statLeaderBlock {
  margin-bottom: 50px;
  margin-top: 30px !important;
}
.oomSection {
  margin-top: 60px;
}
h1.NewsHomepage-Text {
  color: #6c6c6c;
  font-weight: bold;
  font-size: 20px;
  text-transform: capitalize;
  padding-bottom: 25px;
  text-align: center;
}
h1.orderOfMerit {
  color: #6c6c6c;
  font-weight: bold;
  font-size: 20px;
  text-transform: capitalize;
  padding-bottom: 25px;
  text-align: center;
}
h1.greatnessTitle {
  color: #6c6c6c;
  font-weight: bold;
  font-size: 20px;
  text-transform: capitalize;
  padding-bottom: 25px;
  padding-top: 25px;
}
p.greatnessPara {
  color: #6c6c6c;
  font-size: 12px;
  width: 800px;
  text-align: center;
  margin: auto;
}
.greatnessSection {
  text-align: center;
  /* padding-top: 60px; */
  padding-bottom: 60px;
}
.theScoreBack {
  background-color: #f2f2f2;
  padding-top: 3em;
  padding-bottom: 4.5em;
}
span.advertCen {
  text-align: center;
  display: block;
  margin-top: 100px;
  font-weight: bold;
  font-size: 20pt;
}
span.advertCen {
  text-align: center;
}
.logowidth {
  margin-right: 10px;
}
.newsLogos {
  display: inline-flex;
  float: right;
  margin-top: 30px;
}
.socialLogosFooter {
  width: 22px;
  height: 22px;
}
span.whitetext {
  color: #fff;
  text-align: center;
  display: block;
  padding-top: 8px;
  font-size: 11px;
  font-weight: bold;
  /* font: normal normal normal 12px Barlow; */
  line-height: 19px;
  height: 35px;
}
.whiteblock {
  border: 1px solid white;
  width: 200px;
  height: 35px;
  margin: auto;
  margin-top: 30px;
  background-color: #93278f;
}
.whiteblock > a {
  text-decoration: none;
}
.whiteblock:hover {
  border: 1px solid white;
  width: 200px;
  height: 35px;
  margin: auto;
  margin-top: 30px;
  background-color: #f8635f;
}
.newsBackground {
  /* background-image: url(https://updated.sunshinetour.com/wp-content/uploads/2022/07/GrassBackground.png);
  */
  background-color: #f2f2f2;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 150px;
  padding-bottom: 90px;
}
.activeBtn {
  background-color: #93278f !important;
}
.pastbtnRow {
  margin-top: 30px;
}
.pastbtn:hover {
  text-align: center;
  display: block;
  background: #93278f;
  border: none;
  color: #fff;
  border-radius: 0;
  padding: 5px 20px;
  width: 100%;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  margin-right: 20px;
}
.pastbtn {
  text-align: center;
  display: block;
  background: #f8635f;
  border: none;
  color: #fff;
  border-radius: 0;
  padding: 5px 20px;
  width: 100%;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  margin-right: 20px;
}
.middleAd-above-vid {
  /* margin-bottom: 10em;
  margin-top: 2em; */
}
.title {
  font-weight: 500;
  font-family: "gotham book", "roboto", sans-serif !important;
  color: #026034;
  font-size: 23pt;
  margin-top: 1em;
  line-height: 1.1;
  /* letter-spacing: 2px; */
}
.Oom {
  margin-top: 100px !important;
}
.report {
  padding: 25px;
  border-radius: 20px;
  /* background-color: white; */
}

::v-deep .nav-tabs {
  padding-bottom: 0em;
  border: 0;
  background: #f8635f;
  border-radius: 10px 10px 0px 0px;
  margin: auto;
  width: 100%;
  display: block;
}
::v-deep .nav-tabs .nav-link.active {
  border-radius: 10px;
  /* background-color: transparent !important; */
  color: #fff !important;
  padding: 5px 20px;
  font-weight: bold;
  text-align: center;
}
::v-deep .nav-tabs .nav-link {
  border-radius: 10px;
  /* background-color: transparent !important; */
  color: #93278f !important;
  padding: 5px 20px;
  border-color: transparent !important;
  font-weight: bold;
}
.leadOomHead {
  color: #026034;
  font-weight: 700;
  font-size: 20pt;
  padding-top: 50px;
  line-height: 25px;
  margin-bottom: -30px;
}
.secTitle {
  color: #026034;
  font-weight: 700;
  font-size: 20pt;
  margin-top: 0;
  padding-top: 3em;
  padding-bottom: 1em;
}
.sepPad {
  padding: 50px 0 0 0;
}
::v-deep .slider > p > iframe {
  width: 100%;
  margin-bottom: 50px;
  background-color: black;
}

@media only screen and (max-width: 480px) {
  .bottomAdBanner {
    padding: 15px 0;
  }
  ::v-deep .main {
    overflow: scroll;
  }
}
@media only screen and (max-width: 500px) {
  .report {
    padding: 25px;
    border-radius: 20px;
    padding-left: 0px !important;
    padding-right: 0px !important;
    /* background-color: white; */
  }
  ::v-deep th {
    font-size: 11px;
  }
}
@media only screen and (max-width: 768px) {
  h1.orderOfMerit.TitleStatLeader {
    margin-bottom: 30px;
  }
  span.whitetext {
    color: #fff;
    text-align: center;
    display: block;
    padding-top: 8px;
    font-size: 11px;
    font-weight: bold;
    /* font: normal normal normal 12px Barlow; */
    line-height: 19px;
    height: 37px;
  }
  .mobHide {
    display: none;
  }
  .leadOomHead {
    margin-bottom: 0px;
  }
  ::v-deep .nav-tabs {
    padding: 0em 0;
  }
  ::v-deep .table__cell {
    transform: skew(0deg);
    position: relative;
    width: 430px;
    align-items: center;
    justify-content: center;
    transition: width 500ms cubic-bezier(0.4, 0, 0.2, 1);
    background-image: linear-gradient(#93278f, #003b1f);
    border-left: 1px solid grey;
  }
  ::v-deep .current.table__cell > span > a.tournInfoBtn {
    opacity: 1;
    transition-delay: 300ms;
    width: 400px;
    z-index: 9999;
    position: relative;
    top: -15px;
  }
}
@media only screen and (max-width: 990px) {
  button.btn.pastbtn.btn-secondary {
    border-radius: 0px;
  }
  button.btn.pastbtn.btn-secondary.activeBtn {
    border-radius: 0px;
  }
  .pastbtnRow[data-v-7eb2bc79] {
    margin-top: 30px;
    display: block;
  }
  .pastbtn {
    margin-top: 0;
    margin-bottom: 0em;
    margin-right: 0px;
  }
  ::v-deep .FullListingBtn > a {
    color: #fff !important;
    text-decoration: none;
    font-size: 12px;
    padding-left: 0px;
  }
  ::v-deep .leaderboardPosHome.container {
    margin-top: -70px;
    z-index: 999;
    position: relative;
  }
  ::v-deep p.greatnessPara {
    color: #6c6c6c;
    font-size: 12px;
    width: 100%;
    text-align: center;
    margin: auto;
  }
  .whiteblock {
    width: 100%;
  }
  .newsLogos {
    float: none;
  }
  .logoBlock {
    text-align: center;
  }
}

@media only screen and (min-width: 991px) {
  .leaderboardPosHome {
    display: none;
  }
}
@media only screen and (max-width: 1200px) {
  ::v-deep img.img-fluid.w-100.d-block {
    /* display: none!important; */
    /* height: 405px; */
  }
}
@media only screen and (max-width: 768px) {
  .formSection {
    padding-top: 30px;
    background: white;
    padding: 0;
    font-size: 13pt;
    color: #00477c;
    padding-top: 30px;
  }
  .nocon {
    padding-left: 0;
    padding-right: 0;
  }
  .appImage {
    width: 100%;
    position: initial;
    margin-top: 0;
  }
  .home.container.nopadMod {
    padding: 0px;
    background-color: #fff;
  }
  .mobHide {
    display: none;
  }
  .mobShow {
    display: block;
  }
}
@media only screen and (max-width: 1400px) {
  .appImageLeft {
    display: none;
  }
  .appImage {
    width: 100%;
    position: inherit;
    right: 12em;
    margin-top: 0px;
  }
  .nocon {
    padding-left: 0;
    padding-right: 0;
    margin-left: 0px;
    margin-right: 0px;
  }
}
@media only screen and (min-width: 769px) {
  .deskHide{
    display: none;
  }
}
</style>
